
import PetDetailsPage from './pet-details/PetDetailsPage';

const PetDetails = () => {
  return <PetDetailsPage />;
};

export default PetDetails;
